import { apiFetch } from './core'

export async function getSmtpSettings() {
  return apiFetch('/api/settings/email')
}

export async function saveSmtpSettings(payload) {
  return apiFetch('/api/settings/email', {
    method: 'PUT',
    body: payload,
  })
}

export async function testSmtp(toEmail) {
  return apiFetch('/api/settings/email/test', {
    method: 'POST',
    body: { toEmail },
  })
}

export async function getN8nSettings() {
  return apiFetch('/api/settings/automations')
}

export async function saveN8nSettings(payload) {
  return apiFetch('/api/settings/automations', {
    method: 'PUT',
    body: payload,
  })
}

export async function testN8n() {
  return apiFetch('/api/settings/automations/test', {
    method: 'POST',
  })
}

export async function getTenantProfile() {
  return apiFetch('/api/settings/tenant')
}

export async function saveTenantProfile(payload) {
  return apiFetch('/api/settings/tenant', {
    method: 'PATCH',
    body: payload,
  })
}

export async function getAppSettings() {
  return apiFetch('/api/settings')
}

export async function saveAppSettings(payload) {
  return apiFetch('/api/settings', {
    method: 'PUT',
    body: payload,
  })
}

export async function getModulesSettings() {
  return apiFetch('/api/settings/modules')
}

export async function saveModulesSettings(modules) {
  return apiFetch('/api/settings/modules', {
    method: 'PATCH',
    body: { modules },
  })
}

export async function getOnboardingStatus() {
  return apiFetch('/api/settings/onboarding/status')
}

export async function completeOnboarding(stepsCompleted = []) {
  return apiFetch('/api/settings/onboarding/complete', {
    method: 'POST',
    body: { steps_completed: stepsCompleted },
  })
}

export async function saveOnboardingProgress(step, progressPercent) {
  return apiFetch('/api/settings/onboarding/progress', {
    method: 'POST',
    body: { step, progress_percent: progressPercent },
  })
}
